import * as React from 'react';
import styled from 'styled-components';
import {StudentAfterAccessProps} from './types';
import Row from 'components/Row';
import Column from 'components/Column';
import Radio from 'components/Radio';
import Input, {InputScale} from 'components/Input';
import {ActionButton, ActionSheet, ActionType} from 'components/ActionSheet';
import ControlButton from 'components/ControlButton';
import {IconLock} from 'icons';

const Inline = styled.div`
  gap: 6px;
  align-items: center;
  grid-auto-flow: column;
  display: inline-grid;
`;

/**
 *
 * @param {StudentAfterAccessProps} props
 * @return {React.ReactElement<StudentAfterAccessProps>}
 * @constructor
 */
export default function StudentAfterAccess(
    props: StudentAfterAccessProps,
): React.ReactElement<StudentAfterAccessProps> {
  /**
   * Render trigger.
   * @param {() => void} open
   * @param {() => void} close
   * @return {JSX.Element}
   */
  function getTrigger(
    open: () => void,
    close: () => void,
  ): JSX.Element {
    return (
      <ControlButton onClick={() => open()}>
        <IconLock />
      </ControlButton>
    );
  }

  /**
   * Get actions.
   * @return {ActionButton[]}
   */
  function getActions(): ActionButton[] {
    return [
      {
        type: ActionType.Submit,
        children: <span>Применить</span>,
      },
    ];
  }

  return (
    <ActionSheet
      title="Доступ после прохождения"
      trigger={getTrigger}
      actions={getActions()}
      {...props}
    >
      <Row>
        <Column>
          <Radio
            name="student-access"
            label="Закрыт"
          />
        </Column>
      </Row>
      <Row>
        <Column>
          <Radio
            name="student-access"
            label={(
              <Inline>
                <span>Дней:</span>
                <Input scale={InputScale.Small} />
              </Inline>
            )}
          />
        </Column>
      </Row>
      <Row>
        <Column>
          <Radio
            name="student-access"
            label="Навсегда"
          />
        </Column>
      </Row>
    </ActionSheet>
  );
}
